<div>
  <tag
    *ngFor="let tag of tags; let tagIndex = index"
    [tag]="tag"
    (onDeleteTag)="removeTag($event)"
  ></tag>
</div>
